import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';
import { superUserColumnDefs } from './columnDefinitions';
import { periodColumnDefinition } from '../../shared/columnDefinitions';

const keyBy = (key, collection) => collection.reduce((acc, item) => {
  acc[item[key]] = item;
  return acc;
}, {});

export default ({
  periodName,
  categoryDescription,
  tagsList,
  categoryViews,
  hideDecimals,
  negativeMinus,
  shouldDisplayZero,
  environmentSuffix,
}) => {
  const categoryView = keyBy('value', categoryViews);
  const tagsByName = keyBy('tagName', tagsList);

  const tagsWithPeriods = tagsList.map(tag => ({
    ...tag,
    periodName,
    catView: tag.catView && categoryView[tag.catView].name,
    defaultTag: tag.defaultTag && tagsByName[tag.defaultTag].description,
  }));

  const sheetData = [
    {
      name: 'Tags',
      type: SheetExportTypes.GRID,
      descriptionColumnIndex: -1,
      columnDefinitions: [
        {
          ...periodColumnDefinition,
          rowGroup: true,
          hide: true,
          enableGroup: true,
          minWidth: 200,
        },
        ...superUserColumnDefs,
      ],
      data: tagsWithPeriods,
      options: {
        hideDecimals,
        negativeMinus,
        shouldDisplayZero,
      },
    },
    {
      name: 'Metadata',
      type: SheetExportTypes.CUSTOM,
      data: [],
      options: {
        addTimestamp: true,
      },
    },
  ];

  xlsxExport({
    sheetData,
    metadata: {
      fileName: `TLS_Tags_${categoryDescription}_${periodName}${environmentSuffix}`,
      disableHeaderRendering: true,
    },
  });
};
